import { useFormik } from "formik";
import NovaSenhaForm from "../../components/authentication/NovaSenha/NovaSenhaForm.js";
import PublicPageLayout from "../../layouts/PublicLayout";
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import React, { useEffect, useState } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import axios from 'axios';
import functions from "../../constants/serverFunctions.js";





export default function NovaSenha() {
  const { token } = useParams();
  const history = useHistory();
  const [tokenValido, setTokenValido] = useState(false);

  // valida token com backend
  const validarTokenResetSenha = async (token) => {
    const url = `${functions.senha.VALIDAR_TOKEN_ID_USER}?token=${token}`;
    const response = await axios.get(url);
    return response.data;
  };

  useEffect(() => {
    const validarToken = async () => {
      try {
        const data = await validarTokenResetSenha(token);

        if (data?.isValid) {
          setTokenValido(true);
        } else {
          history.push('/login');
        }
      } catch (error) {
        console.error("Erro ao validar token:", error);
        if (error.response?.status === 401) {
          history.push('/401');
        } else {
          history.push('/login');
        }
      }
    };

    if (token) validarToken();
  }, [token, history]);

  // função que será chamada pelo Formik
  const handleEnviarNovaSenha = async (values, token) => {
    try {
      await enviarNovaSenha(token, values.senha);
      history.push('/login'); 
    } catch (err) {
      alert(err.message);
    }
  };

  // aqui é onde chamamos o hook Formik, passando token
  const formik = useNovaSenhaFormik(handleEnviarNovaSenha, token);

  return (
    <>
      {tokenValido && (
        <PublicPageLayout
          title="Redefinir Senha | ASSEMBLEIACOOP"
          FormComponent={<NovaSenhaForm formik={formik} />}
        />      
        )}
    </>
  );
}


async function enviarNovaSenha(tokenTemp, senha) {
  const url = functions.senha.RESETAR_SENHA_USUARIO;

  try {
    const response = await axios.post(url, { token:tokenTemp, novaSenha:senha });
    return response.data;
  } catch (error) {
    console.error("Erro ao enviar nova senha:", error);

    if (error.response) {
      const { status, data } = error.response;
      if (status === 401) {
        throw new Error(data.message || "Token expirado ou inválido.");
      }
      throw new Error(data.message || "Erro ao alterar a senha. Tente novamente.");
    }

    throw new Error("Erro de conexão. Verifique sua internet e tente novamente.");
  }
}


export function useNovaSenhaFormik(onSubmit, token) {
  const NovaSenhaSchema = Yup.object().shape({
    senha: Yup.string()
      .min(6, 'A senha deve ter pelo menos 6 caracteres')
      .required('Campo obrigatório'),
    confirmarSenha: Yup.string()
      .oneOf([Yup.ref('senha'), null], 'As senhas não coincidem')
      .required('Campo obrigatório'),
  });

  const formik = useFormik({
    initialValues: {
      senha: '',
      confirmarSenha: '',
    },
    validationSchema: NovaSenhaSchema,
    onSubmit: async (values, { setSubmitting, resetForm }) => {
      try {
        setSubmitting(true);

        if (onSubmit) {
          await onSubmit(values, token);
        }
        console.log("Senha alterada com sucesso");
        toast.success('Senha alterada com sucesso!', { autoClose: 3000 });
        resetForm();
      } catch (error) {
        toast.error(error.message || 'Erro ao alterar a senha', { autoClose: 3000 });
      } finally {
        setSubmitting(false);
      }
    },
  });

  return formik;
}
